import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { DatePipe, NgIf } from "@angular/common";

/**
 * The stacked DAY / NUMBER / MONTH chip. Used on cards, detail headers and
 * admin rows so a date looks identical everywhere in the events section.
 */
@Component({
    selector: "app-date-chip",
    standalone: true,
    imports: [NgIf, DatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./date-chip.component.html",
    styleUrl: "./date-chip.component.scss",
})
export class DateChipComponent {
    /** null renders the "TBA" state rather than nothing, so layouts stay stable. */
    @Input() date: Date | string | null = null;

    get value(): Date | null {
        if (!this.date) {
            return null;
        }
        const d = this.date instanceof Date ? this.date : new Date(this.date);
        return isNaN(d.getTime()) ? null : d;
    }
}
